var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44444 8.44444H15.5556M8.44444 12H13.7778M13.7778 16.4444H12.8889L8.44444 19.1111V16.4444H6.66667C5.95942 16.4444 5.28115 16.1635 4.78105 15.6634C4.28095 15.1633 4 14.485 4 13.7778V6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H17.3333C18.0406 4 18.7189 4.28095 19.219 4.78105C19.719 5.28115 20 5.95942 20 6.66667V10.6667M18.2222 20V20.0089M18.2222 17.3333C18.6207 17.3321 19.0072 17.1971 19.32 16.9502C19.6327 16.7032 19.8536 16.3585 19.9472 15.9711C20.0408 15.5838 20.0017 15.1763 19.8363 14.8137C19.6709 14.4512 19.3886 14.1547 19.0347 13.9716C18.681 13.7904 18.2765 13.7342 17.8869 13.8122C17.4973 13.8901 17.1456 14.0976 16.8889 14.4009",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionType);
export default __webpack_public_path__ + "static/media/QuestionType.0fe6572343615c8f57af27c3f489b4ea.svg";
export { ForwardRef as ReactComponent };